import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getBridgeConfig } from './config';

let app: FirebaseApp | null = null;
let authInstance: Auth | null = null;

export function getBridgeAuth(): Auth {
  if (authInstance) return authInstance;
  const cfg = getBridgeConfig();
  app = initializeApp(cfg.firebase);
  authInstance = getAuth(app);
  return authInstance;
}
